import { render, staticRenderFns } from "./SavePaperDialog.vue?vue&type=template&id=f7f84f04&scoped=true&"
import script from "./SavePaperDialog.vue?vue&type=script&lang=js&"
export * from "./SavePaperDialog.vue?vue&type=script&lang=js&"
import style0 from "./SavePaperDialog.vue?vue&type=style&index=0&id=f7f84f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f84f04",
  null
  
)

export default component.exports